import Box from '~/common/components/Box';
import CircularProgress from '~/common/components/Spinner/index';
import Text from '~/common/components/Texts/Text';

type SpinnerProps = {
  loadingMessage?: string;
  'data-testid'?: string;
  backgroundColor?: string;
  height?: string;
};

const Spinner = ({
  loadingMessage,
  backgroundColor,
  height,
  ...props
}: SpinnerProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        borderTopRightRadius: '6px',
        borderBottomRightRadius: '6px',
        borderLeft: 'none',
        backgroundColor: backgroundColor ?? 'gray.50',
        minH: height ?? '614px',
        maxHeight: 'calc(100% - 259px)',
        height: '100%',
      }}
      data-testid={props['data-testid']}
    >
      <CircularProgress
        role="progressbar"
        aria-busy="true"
        aria-live="polite"
        aria-label="Loading"
      />

      {loadingMessage && (
        <Text as="h2" pt="1rem">
          {loadingMessage}
        </Text>
      )}
    </Box>
  );
};

export default Spinner;
